// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import commonCss from './assets/css/common.css'
import './assets/css/iconfont.css'
import commonJs from './assets/js/common'
import model from './components/myComponents/model'
import page from './components/myComponents/page'
import imgScorll from './components/myComponents/imgScorll'
import allTop from './components/myComponents/allTop'
import allMallSerch from './components/myComponents/allMallSerch'
import headerSearch from './components/myComponents/headerSearch'
import axiox from './assets/js/axios'
import babelpolyfill from 'babel-polyfill'
// eslint-disable-next-line import/no-duplicates
import pubilshSet from './assets/js/pubilshSet'
// eslint-disable-next-line import/no-duplicates
import baseUrl from './assets/js/pubilshSet'

Vue.config.devtools = true
Vue.use(commonCss)
Vue.use(babelpolyfill)
Vue.prototype.$commonJs = commonJs
Vue.prototype.$axiox = axiox
Vue.prototype.$baseUrl = pubilshSet.baseUrl
Vue.component('model', model)
Vue.component('page', page)
Vue.component('imgScorll', imgScorll)
Vue.component('headerSearch', headerSearch)
Vue.component('allTop', allTop)
Vue.component('allMallSerch', allMallSerch)
// 判断是IE几
let IENum = -1
let userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
let isChrome = userAgent.indexOf('Chrome') > -1 // 判断是不是谷歌
let isiPad = userAgent.indexOf('iPad') > -1 // 判断是不是ipad
let isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
if (isIE) {
  let reIE = new RegExp('MSIE (\\d+\\.\\d+);')
  reIE.test(userAgent)
  let fIEVersion = parseFloat(RegExp['$1'])
  if (fIEVersion === 7) {
    IENum = 7
  } else if (fIEVersion === 8) {
    IENum = 8
  } else if (fIEVersion === 9) {
    IENum = 9
  } else if (fIEVersion === 10) {
    IENum = 10
  } else {
    IENum = 6 // IE版本<=7
  }
} else if (isEdge) {
  IENum = 'edge' // edge
} else if (isIE11) {
  IENum = 11 // IE11
} else {
  if (isChrome) {
    IENum = -1 // 是谷歌浏览器内核
  } else {
    IENum = -2 // 不是ie浏览器且不是谷歌
  }
}
Vue.prototype.$IENum = IENum
Vue.prototype.$isiPad = isiPad

router.beforeEach((to, from, next) => {
  console.log(to, 'to', window.location.host, baseUrl.bgSearchHostUrl + 'search')
  if (window.location.host === 'www.baigang.cn' && to.path === '/') {
    window.location.href = baseUrl.bgSearchHostUrl + 'search'
    window.reload()
  } else {
    next()
  }
  // if (from.path === '/newAddCustomer' && (to.path==='/customerList' || to.path === '/selectItem') && store.state.newCusAlert) {
  //   return
  // } else {
  //   next()
  // }
})

let vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
Vue.use({
  vm
})



// WEBPACK FOOTER //
// ./src/main.js